import React from 'react';
import { NavBarCategoryItem } from '../../libs/IdeLink.Web.Common/src/components/NavBar/components';
import { NavbarModuleItem } from '../../libs/IdeLink.Web.Common/src/components/NavBar/components/NavBarItem/NavBarItem';
import { ModuleKey } from '../modules/Module';

type NavbarItemType = Partial<Record<ModuleKey, NavbarModuleItem[]>>;

export type NavbarContextType = {
	items: NavbarItemType;
	categories: NavBarCategoryItem[];
	register: (moduleKey: ModuleKey, items: NavbarModuleItem[]) => void;
	unregister: (moduleKey: ModuleKey) => void;
};

export type NavBarCategoryOrderDefinition = { categoryName?: string; moduleKeys: ModuleKey[] };
export type NavBarOrderDefinition = NavBarCategoryOrderDefinition[];

const defaultOrder: NavBarOrderDefinition = [
	{
		categoryName: '',
		moduleKeys: [
			'OffersModule',
			'NewsModule',
			'EventsModule',
			'SurveysModule',
			'VideosModule',
			'QuizzesModule',
			'ChallengesModule',
			'CollectionsModule',
			'AuditsModule',
			'IndicatorsModule',
			'ContactsModule',
		],
	},
	{
		categoryName: '',
		moduleKeys: [
			'BackUsersModule',
			'TeamsModule',
			'AreasModule',
			'SectorsModule',
			'ShopsModule',
			'FrontUsersModule',
			'StatsModule',
			'RolesModule',
			'TagsModule',
		],
	},
];

export const NavbarContext = React.createContext<NavbarContextType>({
	items: {},
	categories: [],
	register: () => {},
	unregister: () => {},
});

const initialItems: NavbarItemType = {};

export const NavbarContextProvider = ({
	children,
	orderConfig,
}: React.PropsWithChildren<{ orderConfig?: NavBarOrderDefinition }>) => {
	const [items, setItems] = React.useState<NavbarItemType>(initialItems);
	const register = (moduleId: string, routes: NavbarModuleItem[]) => {
		setItems((r) => ({ ...r, [moduleId]: routes }));
	};
	const unregister = (moduleId: ModuleKey) => {
		setItems((r) => {
			const { [moduleId]: _, ...rest } = r;
			return rest;
		});
	};

	const order = orderConfig ?? defaultOrder; //TODO: PGU voir pour faire un merge des deux.

	const categories: NavBarCategoryItem[] = order.map(
		(c): NavBarCategoryItem => ({
			categoryName: c.categoryName,
			items: c.moduleKeys
				.map((key) => items[key])
				.filter((i) => i !== undefined)
				.flat() as NavbarModuleItem[],
		})
	);

	return (
		<NavbarContext.Provider value={{ items, categories, register, unregister }}>
			{children}
		</NavbarContext.Provider>
	);
};
